export function isFlexi24Duration(duration: { amount: number; unit: string }) {
    if (duration) {
        return (
            (duration.amount === 730 && duration.unit === 'days') ||
            (duration.amount === 24 && duration.unit === 'months')
        );
    }
}
